const generateCorrelationId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const rand = Math.random().toString(36).slice(2, 8);
  return `cid-${Date.now().toString(36)}-${rand}`;
};

// The same rule the Lessee Portal API applies to X-Correlation-ID. A cid that fails it would be
// replaced by the API, splitting the page events from the API and ReadyDocs lines, so it is not used.
const USABLE_CORRELATION_ID = /^[A-Za-z0-9._:-]{1,128}$/;

export const isUsableCorrelationId = (value) => typeof value === 'string' && USABLE_CORRELATION_ID.test(value);

export const getCorrelationId = (appNumber, providedCid) => {
  const fromParam = typeof providedCid === 'string' ? providedCid.trim() : '';
  if (isUsableCorrelationId(fromParam)) return fromParam;

  return generateCorrelationId();
};

export const appendCidToUrl = (url, cid) => {
  if (!cid || !url) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}cid=${encodeURIComponent(cid)}`;
};

// The correlation id of the page that is open, sent as X-Correlation-ID on Lessee Portal API calls.
// The MOP page sets it when it opens and clears it when it closes.
let activeCorrelationId = null;

export const CORRELATION_ID_HEADER = 'X-Correlation-ID';

export const setActiveCorrelationId = (cid) => {
  activeCorrelationId = typeof cid === 'string' && cid.trim().length > 0 ? cid.trim() : null;
};

export const getActiveCorrelationId = () => activeCorrelationId;

// Clears the active id only when it is still the given one, so a newer page's id is kept.
export const clearActiveCorrelationId = (cid) => {
  if (cid === undefined || cid === activeCorrelationId) {
    activeCorrelationId = null;
  }
};

/**
 * Axios request interceptor. Adds X-Correlation-ID with the active correlation id to requests
 * for the API origin. Requests to other origins are left alone. A header already set by the caller is kept.
 */
export const attachCorrelationIdHeader = (config, apiOrigin) => {
  const cid = activeCorrelationId;
  if (!cid || !config) return config;

  let sameOrigin = true;
  try {
    const target = new URL(config.url || '', config.baseURL || undefined);
    sameOrigin = !apiOrigin || target.origin === apiOrigin;
  } catch {
    sameOrigin = true; // relative url with no base, so it goes to the API
  }
  if (!sameOrigin) return config;

  config.headers = config.headers || {};
  const hasHeader = Object.keys(config.headers).some((k) => k.toLowerCase() === CORRELATION_ID_HEADER.toLowerCase());
  if (!hasHeader) {
    config.headers[CORRELATION_ID_HEADER] = cid;
  }
  return config;
};
